import React, { useEffect, useState } from "react"
import Breadcrumbs from "../../../components/Common/Breadcrumb"
import { useDispatch, useSelector } from "react-redux"
import DeleteModal from "components/Common/DeleteModal"
import SAlert from "components/Alert"
import {
  getProviderCommodityClassifications,
  getProviderCurrencies,
  getProviderFundCodes,
  getProviderIps,
  getProviderItemCategories,
  getProviderProjects,
  getProviderProvinces,
  getProviderShipments,
} from "store/provider-dashboard/provider-dashboard-action"
import ProviderOutListComponent from "components/ProviderOut/list"
import {
  deleteManyProviderOut,
  deleteProviderOut,
  getProviderOuts,
} from "store/provider-out/provider-out-action"
import useSearch from "hooks/useSearch"
import ProviderOutDetailModal from "components/ProviderOut/details"
import { exportProviderDistributionReport } from "store/provider-reports/p-report-action"

const ProviderOutList = () => {
  // Meta title
  document.title = "Distributions"

  const dispatch = useDispatch()
  const { data, error, loading } = useSelector(state => state.providerOut)
  const permissions = useSelector(state => state.auth.permissions)
  const [deleteModal, setDeleteModal] = useState(false)
  const [proOut, setProOut] = useState(null)
  const [search, setSearch] = useState(null)
  const [pageNumber, setPageNumber] = useState(10)
  const [according, setAccording] = useState({ order: "desc", name: "id" })
  const [advnacedSearch, setAdvancedSearch] = useState({})
  const [detailModal, setDetailModal] = useState(false)

  // Current status of the export process for the report, retrieved from the Redux store
  const exportStatus = useSelector(
    state => state.providerReports.providerExportDistributionReport
  )

  // Handle record deletion and close the delete modal
  // Dispatch delete action for the selected record
  // Close the delete modal
  const handleDeleteFunc = data => {
    if (proOut) {
      dispatch(deleteProviderOut(proOut.id))
    }
    setDeleteModal(false)
  }

  // Handle multiple delete action when top delete button is clicked
  const onAllDeleteClicked = ids => {
    if (ids.length > 0) {
      dispatch(deleteManyProviderOut(ids))
    } else {
      SAlert({ text: "no receipt selected", status: "info" })
    }
  }

  // Set the record to be deleted and open the delete modal
  // Store the selected record for deletion
  // Open the delete confirmation modal
  const onClickDelete = data => {
    // Check if record is locked
    if (data.locked) {
      SAlert({
        title: "Cannot Delete",
        text: "This record cannot be modified until the transfer is approved or rejected.",
        status: "warning",
      })
      return
    }
    setProOut(data)
    setDeleteModal(true)
  }

  // Fetches new data when a page number is clicked
  const onPageClick = link => {
    dispatch(
      getProviderOuts(link.url, pageNumber, according, search, advnacedSearch)
    )
  }

  // Updates search value when a new search is performed
  const onSearchHandler = value => {
    setSearch(value)
  }

  // Updates the number of rows displayed based on user selection (e.g., 10, 20, 50)
  const onChangeRowNumber = value => {
    setPageNumber(value)
  }

  // Updates the ordering based on user selection
  const onChangeOrdering = value => {
    if (value.order) {
      setAccording(prev => {
        return { ...prev, order: value.order }
      })
    }
    if (value.name) {
      setAccording(prev => {
        return { ...prev, name: value.name }
      })
    }
  }

  // Custom Search Hook called everytime search updates
  useSearch(
    getProviderOuts(undefined, undefined, undefined, search, advnacedSearch),
    search
  )

  // fetch new data based page number or according changes
  useEffect(() => {
    dispatch(
      getProviderOuts(undefined, pageNumber, according, search, advnacedSearch)
    )
  }, [pageNumber, according])

  // fetch other data for filter selectbox
  useEffect(() => {
    dispatch(getProviderItemCategories())
    dispatch(getProviderProvinces())
    dispatch(getProviderIps())
    dispatch(getProviderProjects())
    dispatch(getProviderCurrencies())
    dispatch(getProviderShipments())
    dispatch(getProviderFundCodes())
    dispatch(getProviderCommodityClassifications())
  }, [])

  // Executes when the advanced search form is submitted
  const onAdvancedSearchSubmit = data => {
    setAdvancedSearch(data)
    dispatch(getProviderOuts(undefined, undefined, undefined, search, data))
  }

  // Trigger export process when Export button is clicked
  const onExportBtnClick = () => {
    dispatch(
      exportProviderDistributionReport(
        pageNumber,
        according,
        search,
        advnacedSearch
      )
    )
  }

  // Show record details in a modal when the detail button is clicked
  const onClickDetail = data => {
    setProOut(data)
    setDetailModal(true)
  }

  return (
    <React.Fragment>
      {/* Delete Modal Component  */}
      <DeleteModal
        show={deleteModal}
        onDeleteClick={handleDeleteFunc}
        onCloseClick={() => setDeleteModal(false)}
      />
      {/* Detail Modal  */}
      <ProviderOutDetailModal
        open={detailModal}
        setOpen={setDetailModal}
        data={proOut}
      />
      <Breadcrumbs title={"Provider"} breadcrumbItem={"Distributions"} />
      {/* Provider Out Distribution Component  */}
      <ProviderOutListComponent
        data={data}
        error={error}
        loading={loading}
        onClickDelete={onClickDelete}
        handleDeleteFunc={handleDeleteFunc}
        onPageClick={onPageClick}
        onSearch={onSearchHandler}
        onChangeRowNumber={onChangeRowNumber}
        onChangeOrdering={onChangeOrdering}
        onAllDeleteClicked={onAllDeleteClicked}
        onAdvancedSearchSubmit={onAdvancedSearchSubmit}
        permissions={permissions}
        onClickDetail={onClickDetail}
        exportStatus={exportStatus}
        onExportBtnClick={onExportBtnClick}
      />
    </React.Fragment>
  )
}

export default ProviderOutList
